import React from 'react';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  topScrollPaper: {
    alignItems: 'flex-start',
    marginTop: '70px',
  },
}));

export const WorkExperienceDeleteDialog = ({
  open,
  setDialogOpen,
  handleProceed,
}: {
  open: boolean;
  setDialogOpen: (value: boolean) => void;
  handleProceed?: () => void;
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <GenericDialog
      open={open}
      disableEscapeKeyDown
      maxWidth="sm"
      classes={{
        scrollPaper: classes.topScrollPaper,
      }}
      onClose={(e, reason) => {
        if (reason === 'backdropClick') return;
        setDialogOpen(false);
      }}
      dialogTitleProps={{
        style: { paddingTop: '20px' },
        text: t('candidate.workExperience.workExperienceGrid.deleteWorkExpModalTitle'),
      }}
      dialogActions={[
        {
          text: 'Cancel',
          color: 'tertiary',
          variant: 'text',
          onClick: () => {
            setDialogOpen(false);
          },
        },
        {
          text: 'Delete',
          variant: 'contained',
          color: 'primary',
          onClick: () => handleProceed(),
          disabled: false,
        },
      ]}
    >
      <Typography mb={5}>{t('candidate.workExperience.workExperienceGrid.deleteWorkExpModalMessage')}</Typography>
    </GenericDialog>
  );
};
